import { forwardRef } from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledCheckBox } from './styles';
import { CheckBoxProps } from './types';

const CheckBoxComponent = forwardRef<HTMLInputElement, CheckBoxProps>(
    ({ options, name, disabled, ...props }, ref) => {
        return (
            <StyledCheckBox
                ref={ref}
                name={name}
                disabled={disabled}
                options={options}
                {...props}
            />
        );
    }
);

CheckBoxComponent.displayName = 'CheckBoxComponent';

export const CheckBox = withTheme(CheckBoxComponent);
